module.exports = __webpack_public_path__ + "img/30_48.2f4bc950.png";